import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "country", "state", "city", "keyword", "suggestions"];
  static values = { selectCity: String };

  connect() {
    this.locale = document.documentElement.lang || "es";
    this.suggestTimer = null;
  }

  disconnect() {
    if (this.suggestTimer) clearTimeout(this.suggestTimer);
  }

  updateStates() {
    const countrySlug = this.countryTarget.value;
    if (!countrySlug) return;

    fetch(`/${this.locale}/states?country_slug=${encodeURIComponent(countrySlug)}`, {
      headers: { Accept: "text/html" }
    })
      .then(response => response.text())
      .then(html => {
        this.stateTarget.innerHTML = `<option value="">${this.stateTarget.dataset.prompt || ""}</option>${html}`;
        this.cityTarget.innerHTML = `<option value="">${this.selectCityValue}</option>`;
      });
  }

  updateCities() {
    const stateSlug = this.stateTarget.value;
    if (!stateSlug) return;

    fetch(`/${this.locale}/cities?state_slug=${encodeURIComponent(stateSlug)}`, {
      headers: { Accept: "text/html" }
    })
      .then(response => response.text())
      .then(html => {
        this.cityTarget.innerHTML = `<option value="">${this.selectCityValue}</option>${html}`;
      });
  }

  suggest(event) {
    const query = event.target.value.trim();
    if (this.suggestTimer) clearTimeout(this.suggestTimer);

    if (query.length < 2) {
      this.suggestionsTarget.classList.add("hidden");
      return;
    }

    this.suggestTimer = setTimeout(() => this.fetchSuggestions(query), 300);
  }

  fetchSuggestions(query) {
    fetch(`/${this.locale}/offers/suggestions?keyword=${encodeURIComponent(query)}`, {
      headers: { Accept: "text/html" }
    })
      .then(response => {
        if (!response.ok) throw new Error("Failed to fetch suggestions");
        return response.text();
      })
      .then(html => {
        this.suggestionsTarget.innerHTML = html;
        this.suggestionsTarget.classList.remove("hidden");
      })
      .catch(error => console.error("Suggestions error:", error));
  }

  selectSuggestion(event) {
    this.keywordTarget.value = event.currentTarget.dataset.value;
    this.suggestionsTarget.classList.add("hidden");
    this.formTarget.requestSubmit();
  }

  submit() {
    this.formTarget.requestSubmit();
  }
}
